"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnsChatWidgetLoader = void 0;
const LoadRequestValidator_1 = require("../validator/LoadRequestValidator");
const WidgetStates_1 = require("../constants/WidgetStates");
class AnsChatWidgetLoader {
    /**
     *  This method when invoked maximizes the widget state and if the widget is already found in
     *  maximize state does not takes any action.
     *  TODO : Improve it further to support AVS-E usecase
     * @param callbackfn if provided used for registering a callback for recording metric and log events related to
     *  widget trigger status.
     */
    static programmaticWidgetTrigger(callbackfn) {
        try {
            const chatIframeWrapper = document.getElementById(`${AnsChatWidgetLoader.ANS_CHAT_WIDGET}WrapperDiv`);
            if (chatIframeWrapper && chatIframeWrapper.style.display !== 'block') {
                chatIframeWrapper.style.display = 'block';
            }
            // @ts-ignore
            const ansWidgetDOM = window.frames[AnsChatWidgetLoader.ANS_CHAT_WIDGET];
            const chatIconClassName = 'floating-chat enter';
            if (ansWidgetDOM && ansWidgetDOM.document.getElementsByClassName(chatIconClassName) &&
                ansWidgetDOM.document.getElementsByClassName(chatIconClassName).length === 1 && chatIframeWrapper &&
                chatIframeWrapper.getAttribute(AnsChatWidgetLoader.WIDGET_STATE) !== WidgetStates_1.WidgetStates.MAX) {
                ansWidgetDOM.document.getElementsByClassName(chatIconClassName)[0].click();
                if (callbackfn) {
                    callbackfn(WidgetStates_1.WidgetTriggerStatus.SUCCESS);
                }
            }
        }
        catch (err) {
            if (callbackfn) {
                callbackfn(WidgetStates_1.WidgetTriggerStatus.FAIL, {
                    errorStack: err
                });
            }
        }
    }
    /**
     * Returns the position of the footer on the page.
     * As of now, specific to vendorCentral as the footer id used is specific to vendor central.
     * The selected html element is table(id : layout-footer) inside footer div(id : vss-footer)
     * TODO : Take platform as one of the input arguments so that the behaviour can be
     * customised based on that.
     * @returns {footerCoordinates}
     */
    static getPageFooterCoordinates() {
        var pageFooterTableElement = document.getElementById("layout-footer");
        var footerCoordinates = undefined;
        if (pageFooterTableElement) {
            footerCoordinates = pageFooterTableElement.getBoundingClientRect();
        }
        return footerCoordinates;
    }
    /**
     * Method to calculate the width for Min Badge Widget State.
     * @param widgetWidth
     * @private
     */
    static getMinBadgeWidth(widgetWidth) {
        return widgetWidth
            ? Math.max(parseInt(WidgetStates_1.widgetStatesProps.MIN.width), Math.min((parseInt(widgetWidth)) - WidgetStates_1.MIN_BADGE_REDUCED_WIDTH_ADJUSTED, parseInt(WidgetStates_1.widgetStatesProps.MIN_BADGE.width))).toString()
            : WidgetStates_1.widgetStatesProps.MIN_BADGE.width;
    }
    /**
     * Method to calculate the height of Min Badge Widget State.
     * @param widgetHeight
     * @private
     */
    static getMinBadgeHeight(widgetHeight) {
        return widgetHeight
            ? Math.max(parseInt(WidgetStates_1.widgetStatesProps.MIN.height), Math.min((parseInt(widgetHeight)) + WidgetStates_1.MIN_BADGE_HEIGHT_ADJUSTED, parseInt(WidgetStates_1.widgetStatesProps.MIN_BADGE.height))).toString()
            : WidgetStates_1.widgetStatesProps.MIN_BADGE.height;
    }
    /**
     * Method to calculate the height of VC-Header.
     * @param vcHeaderElement
     * @private
     */
    static calculateVCHeaderHeight(vcHeaderElement) {
        let height = WidgetStates_1.VC_HEADER_HEIGHT; // Hardcoding a fallback value here
        if (vcHeaderElement && vcHeaderElement.scrollHeight) {
            height = (Number)(vcHeaderElement.scrollHeight);
        }
        return height;
    }
}
exports.AnsChatWidgetLoader = AnsChatWidgetLoader;
AnsChatWidgetLoader.ANS_CHAT_WIDGET = 'ansChatWidget';
AnsChatWidgetLoader.WIDGET_STATE = 'widgetState';
AnsChatWidgetLoader.IS_RTL = document.dir === "rtl";
/**
 * This method when invoked loads chat widget inside an Iframe on the calling page.
 *
 * @param request : params needed to load widget.
 * @param callbackfn : if provided used for registering a callback for recording metric and log events related to
 *  widget load status.
 *  @param visibility: set the initial load state of widget iframe wrapper
 */
AnsChatWidgetLoader.loadChatWidget = (request, callbackfn, visibility = true) => {
    /**
     * This is needed to ensure that there are never multiple widget load calls on the same page.
     * Especially in case of React applications, it's more probable.
     */
    if (document.getElementById(`${AnsChatWidgetLoader.ANS_CHAT_WIDGET}WrapperDiv`) !== null) {
        return;
    }
    try {
        const violations = LoadRequestValidator_1.LoadRequestValidator.isValid(request);
        if (violations.length > 0) {
            throw new Error(`Validation Failure while validating request params with following  violations: |
                 ${violations.join(',')}`);
        }
        document.addEventListener('ansWidgetLoaded', () => {
            // @ts-ignore
            const frame = window.frames[AnsChatWidgetLoader.ANS_CHAT_WIDGET];
            console.log('ans chat widget loaded event fired');
            if (frame) {
                /**
                 * This is needed to address the iframe related bug in firefox:
                 * https://bugzilla.mozilla.org/show_bug.cgi?id=728151
                 */
                frame.onload = () => {
                    const loadRequestSuccessMssg = 'Successfully completed AnsChatWidget load request';
                    if (callbackfn) {
                        callbackfn(WidgetStates_1.LoadStatus.SUCCESS, loadRequestSuccessMssg);
                    }
                    console.info(loadRequestSuccessMssg);
                    frame.document.dispatchEvent(new CustomEvent('renderAnsibleEvent', {
                        detail: request
                    }));
                    const chatIframeWrapper = document.getElementById(`${AnsChatWidgetLoader.ANS_CHAT_WIDGET}WrapperDiv`);
                    if (chatIframeWrapper !== null && visibility) {
                        // Initialize widget with display none.
                        // Widget is only set to be visible once widget logic invokes show event.
                        chatIframeWrapper.style.display = 'none';
                    }
                };
            }
        });
        let chatIframeWrapperBottomCord = '25px';
        const footerDOMRect = AnsChatWidgetLoader.getPageFooterCoordinates();
        if (footerDOMRect) {
            chatIframeWrapperBottomCord = `${footerDOMRect.bottom - footerDOMRect.top + 5}px`;
        }
        document.addEventListener('resizeAnsWidget', ((event) => {
            var _a, _b, _c;
            const vcHeaderElement = document.getElementById('vc-header');
            const vcHeaderHeight = AnsChatWidgetLoader.calculateVCHeaderHeight(vcHeaderElement);
            const chatWrapper = document.getElementById(`${AnsChatWidgetLoader.ANS_CHAT_WIDGET}WrapperDiv`);
            const requestState = (_a = event.detail) === null || _a === void 0 ? void 0 : _a.widgetState;
            const widgetWidth = (_b = event.detail) === null || _b === void 0 ? void 0 : _b.widgetWidth;
            const widgetHeight = (_c = event.detail) === null || _c === void 0 ? void 0 : _c.widgetHeight;
            if (chatWrapper && requestState !== chatWrapper.getAttribute(`${AnsChatWidgetLoader.WIDGET_STATE}`)) {
                switch (requestState) {
                    case WidgetStates_1.WidgetStates.MIN:
                        chatWrapper.style.height = WidgetStates_1.widgetStatesProps.MIN.height + WidgetStates_1.PIXEL;
                        chatWrapper.style.width = WidgetStates_1.widgetStatesProps.MIN.width + WidgetStates_1.PIXEL;
                        chatIframeWrapper.style.bottom = chatIframeWrapperBottomCord;
                        if (AnsChatWidgetLoader.IS_RTL) {
                            chatIframeWrapper.style.left = WidgetStates_1.WIDGET_POSITION_MARGIN;
                        }
                        else {
                            chatIframeWrapper.style.right = WidgetStates_1.WIDGET_POSITION_MARGIN;
                        }
                        break;
                    case WidgetStates_1.WidgetStates.MAX:
                        chatWrapper.style.height = `calc(${WidgetStates_1.widgetStatesProps.MAX.height}${WidgetStates_1.VIEWPORT_HEIGHT} - ${vcHeaderHeight}${WidgetStates_1.PIXEL})`;
                        chatWrapper.style.width = WidgetStates_1.widgetStatesProps.MAX.width + WidgetStates_1.PIXEL;
                        chatWrapper.style.bottom = '0';
                        if (AnsChatWidgetLoader.IS_RTL) {
                            chatIframeWrapper.style.left = '0';
                        }
                        else {
                            chatIframeWrapper.style.right = '0';
                        }
                        break;
                    case WidgetStates_1.WidgetStates.MIN_BADGE:
                        chatWrapper.style.height = AnsChatWidgetLoader.getMinBadgeHeight(widgetHeight) + WidgetStates_1.PIXEL;
                        chatWrapper.style.width = AnsChatWidgetLoader.getMinBadgeWidth(widgetWidth) + WidgetStates_1.PIXEL;
                        chatIframeWrapper.style.bottom = chatIframeWrapperBottomCord;
                        if (AnsChatWidgetLoader.IS_RTL) {
                            chatIframeWrapper.style.left = WidgetStates_1.WIDGET_POSITION_MARGIN;
                        }
                        else {
                            chatIframeWrapper.style.right = WidgetStates_1.WIDGET_POSITION_MARGIN;
                        }
                        break;
                    case WidgetStates_1.WidgetStates.MIN_WITH_POPOVER:
                        chatWrapper.style.height = WidgetStates_1.widgetStatesProps.MIN_WITH_POPOVER.height + WidgetStates_1.PIXEL;
                        chatWrapper.style.width = WidgetStates_1.widgetStatesProps.MIN_WITH_POPOVER.width + WidgetStates_1.PIXEL;
                        break;
                    case WidgetStates_1.REMOVE_DELPHI_WIDGET:
                        chatWrapper.style.display = 'none';
                        break;
                    case WidgetStates_1.SHOW_DELPHI_WIDGET:
                        chatWrapper.style.display = 'block';
                        break;
                }
                chatWrapper.setAttribute(`${AnsChatWidgetLoader.WIDGET_STATE}`, requestState);
            }
        }));
        const widgetFrame = document.createElement('iframe');
        widgetFrame.id = `${AnsChatWidgetLoader.ANS_CHAT_WIDGET}Frame`;
        widgetFrame.name = `${AnsChatWidgetLoader.ANS_CHAT_WIDGET}`;
        widgetFrame.src = `/${AnsChatWidgetLoader.ANS_CHAT_WIDGET}`;
        widgetFrame.title = 'ansible chat widget frame';
        widgetFrame.height = '100%';
        widgetFrame.width = '100%';
        widgetFrame.frameBorder = '0';
        // Adding sandbox attribute as requested in the ticket: https://t.corp.amazon.com/V1491401029
        widgetFrame.setAttribute('sandbox', 'allow-top-navigation allow-scripts allow-same-origin allow-popups allow-downloads allow-popups-to-escape-sandbox');
        console.log('chat widget initiated');
        const chatIframeWrapper = document.createElement('div');
        chatIframeWrapper.id = `${AnsChatWidgetLoader.ANS_CHAT_WIDGET}WrapperDiv`;
        chatIframeWrapper.style.position = 'fixed';
        chatIframeWrapper.style.width = WidgetStates_1.widgetStatesProps.MIN_BADGE.width + WidgetStates_1.PIXEL;
        chatIframeWrapper.style.bottom = chatIframeWrapperBottomCord;
        chatIframeWrapper.style.height = WidgetStates_1.widgetStatesProps.MIN_BADGE.height + WidgetStates_1.PIXEL;
        chatIframeWrapper.style.display = 'none';
        chatIframeWrapper.style.zIndex = '99';
        if (AnsChatWidgetLoader.IS_RTL) {
            chatIframeWrapper.style.left = WidgetStates_1.WIDGET_POSITION_MARGIN;
        }
        else {
            chatIframeWrapper.style.right = WidgetStates_1.WIDGET_POSITION_MARGIN;
        }
        chatIframeWrapper.setAttribute(`${AnsChatWidgetLoader.WIDGET_STATE}`, WidgetStates_1.WidgetStates.MIN_BADGE);
        chatIframeWrapper.append(widgetFrame);
        document.body.appendChild(chatIframeWrapper);
        console.debug('Reached end of the widget load function');
    }
    catch (err) {
        const loadRequestErrorMssg = `Exception occurred while completing AnsChatWidget load request : 
             | ${JSON.stringify(request)} with following exception : | ${err}`;
        console.error(loadRequestErrorMssg);
        if (callbackfn) {
            callbackfn(WidgetStates_1.LoadStatus.FAIL, loadRequestErrorMssg, {
                errorStack: err
            });
        }
    }
};
